
import AppFileInput from "@/components/FileUpload.vue";
import Vue from "vue";
import { isTypeImage } from "../../utils/file";

export default Vue.extend({
	data() {
		return {
			inputFocused: false,
			storedUrls: [] as string[]
		};
	},
	props: {
		filesDisabled: {
			type: Boolean,
		},
		value: {
			type: String
		},
		files: {
			type: Array as () => File[],
			default: () => []
		},
		isSending: Boolean
	},
	computed: {
		minInputHeight(): number {
			return 40;
		},
		images(): File[] {
			return this.files.filter(f => isTypeImage(f.type));
		},
		otherFiles(): File[] {
			return this.files.filter(f => !isTypeImage(f.type));
		}
	},
	watch: {
		images: {
			deep: true,
			handler() {
				for (let url of this.storedUrls) {
					URL.revokeObjectURL(url);
				}
				this.storedUrls = this.images.map(i => URL.createObjectURL(i));
			}
		}
	},
	methods: {
		onEnter(event: KeyboardEvent) {
		},
		onCtrlEnter(event: KeyboardEvent) {
			event.preventDefault();
			this.sendMessage();
		},
		sendMessage() {
			this.$emit("send", null);
		},
		onMessageInput(value: string) {
			this.$emit("input", value);
		},
		onFileInput(file: File) {
			this.$emit("file", file);
		},
		onFilePasted(file: File) {
			if (this.filesDisabled) return;
			if (!this.inputFocused) return;
			this.$emit("file", file);
		},
		removeFile(file: File) {
			let i = this.files.indexOf(file);
			if (i == -1) return;
			this.files.splice(i, 1);
		}
	},
	destroyed() {
		for (let url of this.storedUrls) {
			URL.revokeObjectURL(url);
		}
	},
	components: {
		AppFileInput
	},
	i18nEx: {
		componentPrefix: "components.chat-components"
	}
});
